<article *ngIf="data">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div
                    *ngIf="
                        !(breakpointService.breakpoint$ | async | breakpointIs : 'mobile') ||
                        (data.desktopImage && !data.mobileImage)
                    "
                >
                    <app-image
                        *ngIf="!data.desktopTouchPoints.length"
                        [image]="data.desktopImage"
                        [width]="1568"
                        [height]="data.isNarrow ? 250 : 520"
                        [index]="data.spotIndex"
                        crop="crop"
                    ></app-image>

                    <app-image-touch-point
                        *ngIf="data.desktopTouchPoints.length"
                        [image]="data.desktopImage"
                        [touchPoints]="data.desktopTouchPoints"
                    ></app-image-touch-point>

                    <a
                        *ngIf="data.desktopLink"
                        [href]="data.desktopLink.url"
                        [target]="data.desktopLink.target || ''"
                        class="kk-link-cover"
                    >
                        <span class="kk-visuallyhidden">
                            {{
                                'general.accessibility.goTo'
                                    | translateSafe : { destination: (data.desktopLink && data.desktopLink.name) || '' }
                            }}
                        </span>
                    </a>
                </div>

                <div *ngIf="(breakpointService.breakpoint$ | async | breakpointIs : 'mobile') && data.mobileImage">
                    <app-image
                        *ngIf="!data.mobileTouchPoints.length"
                        [image]="data.mobileImage"
                        [width]="700"
                        [height]="data.isNarrow ? 150 : 460"
                        [index]="data.spotIndex"
                        crop="crop"
                    ></app-image>

                    <app-image-touch-point
                        *ngIf="data.mobileTouchPoints.length"
                        [image]="data.mobileImage"
                        [touchPoints]="data.mobileTouchPoints"
                    ></app-image-touch-point>

                    <a
                        *ngIf="data.mobileLink"
                        [href]="data.mobileLink.url"
                        [target]="data.mobileLink.target || ''"
                        class="kk-link-cover"
                    >
                        <span class="kk-visuallyhidden"
                        >{{
                                'general.accessibility.goTo'
                                    | translateSafe
                                    : {
                                        destination: (data.mobileLink && data.mobileLink.name) || ''
                                    }
                            }}
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</article>
